
import { Vue, Component, Prop } from "vue-property-decorator";

import LIST_COMPANY_REQUESTS from "@/apollo/jobboard/ListCompanyRequests.gql";

import CardPagination from "@/components/card/CardPagination.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import RequestCard from "@/components/onboarding/RequestCardNew.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholderNew.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";
import EmptyListImageRequests from "@/components/icons/emptyListImages/EmptyListImageRequests.vue";
import commonContractorRequestConditions from "@/data/contractorReguests/commonContractorRequestConditions";

@Component({
  components: {
    EmptyListImageRequests,
    CardPagination,
    LoadingOverlay,
    RequestCard,
    EmptyListPlaceholder,
  },
  apollo: {
    requests: {
      query: LIST_COMPANY_REQUESTS,
      variables() {
        return this.requestsConditions;
      },
      update(data) {
        this.paginationConfig.total = data.total.aggregate.count;
        this.paginationConfig.loadedCount = data.requests.length;
        return data.requests;
      },
    },
  },
})
export default class Requests extends Vue {
  @Prop({ type: String, required: true }) readonly currentUserRole!: string;
  @Prop({ type: String, required: true }) readonly managerFullName!: string;
  @Prop({ type: String, required: true }) readonly managerId!: string;

  requests?: any;

  paginationConfig: PaginationConfig = { ...paginationConfig };

  get requestsConditions(): Object {
    const { page, limit } = this.paginationConfig;
    const nextOffset = page * limit - limit;
    return {
      where: {
        _and: [
          {
            manager_id: { _eq: this.managerId },
          },
          ...commonContractorRequestConditions,
        ],
      },
    };
  }

  get isEmpty(): boolean {
    return !this.requests || this.requests.length === 0;
  }

  get emptyListTitle(): string {
    return `${this.managerFullName} Does Not Have Any Requests Yet`;
  }

  async refetchRequests(): Promise<void> {
    await this.$apollo.queries.requests.refetch();
    this.$emit("requestNumberChanged", this.paginationConfig.total);
  }
}
